// extracted by mini-css-extract-plugin
export default {"breadCrumb":"_26Ll3i1KuJk46BhghollFc","crntNode":"_1hyGKBMN5t9II-fiUygMzv"};